module.exports = '<svg width="22" height="32" viewBox="0 0 22 32"><path d="M21.574 7.622L9.436.238c-.902-.542-1.472-.128-1.472.926v11.014L3.212 8.742c-.842-.634-2.12-.462-2.754.382-.632.84-.502 2.04.342 2.672l5.582 4.202-5.616 4.206a1.907 1.907 0 1 0 1.142 3.438c.398 0 .962-.124 1.306-.38l4.75-3.442v11.016c0 1.054.568 1.47 1.47.928l12.224-7.382c.474-.286.448-.794.018-1.14-2.312-1.856-8.99-7.2-8.938-7.24-.052-.042 6.612-5.388 8.928-7.24.432-.35.382-.858-.092-1.14zm-9.61-1.62l4.302 2.582-4.302 3.442V6.002zm4.302 17.414l-4.302 2.582v-6.024l4.302 3.442z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/bluetooth-1.js
// module id = 1013
// module chunks = 14